import axios from "axios";
import store from "@/store";

// Cliente REST de filtros guardados (api/v1/saved-filters). Módulo plano, no
// mixin: lo consumen tanto componentes (ListPlegable.vue, AttributesTable.vue)
// como el propio services/layers/attributesTable.js, que no tiene `this.$http`
// — mismo criterio que createTerrainApi(axios, ...) en ese archivo. `axios`
// importado directo ya tiene withCredentials:true (main.js lo setea global
// sobre la misma instancia que Vue.prototype.$http), así que no hace falta
// repetirlo en cada llamada.
const base = () => `${store.getters.backendurl}api/v1/saved-filters`;

export const savedFiltersApi = {
  // Una sola petición para todas las capas visibles del mapa — evita N
  // peticiones en ListPlegable (mismo criterio que loadSymbologiesForLayers).
  listForLayers(layerIds) {
    if (!layerIds || !layerIds.length) return Promise.resolve({ data: [] });
    const ids = layerIds.map(id => encodeURIComponent(id)).join(",");
    return axios.get(`${base()}?ids=${ids}`);
  },
  create({ layerId, name, filter }) {
    return axios.post(base(), { id_layer: layerId, name, filter });
  },
  update(id, { name, filter } = {}) {
    const body = {};
    if (name !== undefined) body.name = name;
    if (filter !== undefined) body.filter = filter;
    return axios.put(`${base()}/${id}`, body);
  },
  remove(id) {
    return axios.delete(`${base()}/${id}`);
  },
};
